//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CheckedDescription",
  props: {
    id: {
      type: String
    }
  },

  mounted() {
    this.hide = window.localStorage.getItem(this._id);
  },

  computed: {
    _id: function () {
      return this.id + "_showAgain";
    },
  },

  data: () => ({
    showAgain: false,
    hide: false
  }),

  methods: {
    _clicked: function () {
      window.localStorage.setItem(this._id, this.showAgain);
      this.hide = this.showAgain;
    }
  }
};
